import { useCallback } from 'react';
import { PaymentProviderDto } from '@tiendanube/common';
import { config } from 'App/components/ExternalServices/Amplitude/config';
import { logEvent } from 'commons/utils/tracking';
import { getStatusLabelProps, getStatusTrackingEvent } from './utils';
import useShouldShowPendingNuvemPagoBrasilAsActive from '../useShouldShowPendingNuvemPagoBrasilAsActive';

export function usePatchProviderStatusForNuvemPagoBrasil(
  provider: PaymentProviderDto,
) {
  const {
    hasNuvemPagoBr: isNuvemPagoBr,
    shouldShowPendingAsActive: shouldPatchStatus,
    hasAutoInstallationTag,
    isFeatureFlagEnabled,
  } = useShouldShowPendingNuvemPagoBrasilAsActive([provider]);

  const trackProviderStatus = useCallback(() => {
    if (!isNuvemPagoBr) return;

    const eventName = getStatusTrackingEvent(provider, shouldPatchStatus);

    if (!eventName) return;

    logEvent(eventName, {}, config.nuvempagoInstanceName);
  }, [isNuvemPagoBr, provider, shouldPatchStatus]);

  return {
    isNuvemPagoBr,
    hasAutoInstallationTag,
    isFeatureFlagEnabled,
    shouldPatchStatus,
    trackProviderStatus,
    providerStatusLabelProps: getStatusLabelProps(provider, shouldPatchStatus),
  };
}

export default usePatchProviderStatusForNuvemPagoBrasil;
